import { render, staticRenderFns } from "./MessageReplyList.vue?vue&type=template&id=72673774&scoped=true"
import script from "./MessageReplyList.vue?vue&type=script&lang=js"
export * from "./MessageReplyList.vue?vue&type=script&lang=js"
import style0 from "./MessageReplyList.vue?vue&type=style&index=0&id=72673774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72673774",
  null
  
)

export default component.exports